import React from 'react'
import {
    Button,
    Divider,
    FormControl,
    FormErrorMessage,
    FormLabel,
    Input,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    Select  
} from '@chakra-ui/react'
import { useFormik } from "formik";
import * as Yup from "yup";

// dispute formik value
const disputeValues = {
    email: '',
    disputeType: ''
}

// dispute Yup Validation schema
const disputeSchema = Yup.object({
    email: Yup.string().email().required("Please enter your email"),
    disputeType: Yup.string().required("Please select dispute type")
  });

const DisputeForm = ({ onClose }) => {
    
    const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
    useFormik({
      initialValues: disputeValues,
      validationSchema: disputeSchema,
      onSubmit: (values, action) => {
        console.log(values)
        onClose()
        action.resetForm()
      },
    });
  return (
    <ModalContent>
    <ModalHeader textAlign={'center'}>Settlement Details</ModalHeader>
    <Divider/>
    <ModalCloseButton />
    <ModalBody pb={6}>

        <FormControl mt={4} isInvalid={errors.email && touched.email}>
            <FormLabel>Email ID</FormLabel>
            <Input placeholder='Enter your email' name='email' value={values.email} onChange={handleChange} onBlur={handleBlur} autoComplete="off"/>
            {errors.email && touched.email ? (
            <FormErrorMessage>{errors.email}</FormErrorMessage>
            ) : null}
        </FormControl>

        <FormControl mt={4} isInvalid={errors.disputeType && touched.disputeType}>
            <FormLabel>Settlement Type</FormLabel>
            <Select name="disputeType" placeholder="Select type" onChange={handleChange} onBlur={handleBlur} value={values.disputeType}> 
                <option value='return'>Return</option>
                <option value='settlement'>Settlement</option>
                <option value='generalQuery'>General Query</option>
            </Select>
            {errors.disputeType && touched.disputeType ? (
            <FormErrorMessage>{errors.disputeType}</FormErrorMessage>
            ) : null}
        </FormControl>
    </ModalBody>

    <ModalFooter>
         <Button  mr={3} onClick={onClose}>Cancel</Button>
         <Button colorScheme='blue' onClick={handleSubmit}>
             Save
         </Button>
    </ModalFooter>
</ModalContent>
  )
}

export default DisputeForm